import React, { useState,useRef } from 'react';
import axios from 'axios';
import { Alert, Form, Button, Container, Row, Col } from 'react-bootstrap';
import Rgpd from './rgpd';
import ReCAPTCHA from 'react-google-recaptcha'

function InscriptionArbitre() {
  const [isError, setIsError] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [prenom, setPrenom] = useState('');
  const [date, setDate] = useState('');
  const [contact, setContact] = useState('');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rgpdChecked, setRgpdChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const recaptcha = useRef()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const captchaValue = recaptcha.current.getValue()


    if (!rgpdChecked) {
      setError("Veuillez accepter les conditions d'inscription pour continuer.");
      setIsLoading(false);
      return;
    } else if (!name || !email || !password || !confirm || !date || !contact || !prenom || !file) {
      setError("Veuillez remplir tous les champs du formulaire.");
      setIsLoading(false);
      return;
    }else if (!captchaValue) {
      setError("Veuillez vérifier le captcha");
      setIsLoading(false);
      return;
    }
     else if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append('nom', name);
      formData.append('prenom', prenom);
      formData.append('mail', email);
      formData.append('mdp', password);
      formData.append('confirm_mdp', confirm);
      formData.append('date', date);
      formData.append('contact', contact);
      formData.append('file', file);
      formData.append('captcha', captchaValue);


      const response = await axios.post(`${apiUrl}/inscription/arbitre`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResponse(response.data);
      setError(null);
      setSubmitted(true);
    } catch (error) {
      setResponse(null);
      setSubmitted(false);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setIsError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    );
  }

  if (isError) {
    return (
      <>
      <div id="alert-message" className="alert5" >
        <strong>ERROR SERVEUR ! </strong> <span id="alert-text"></span>
      </div>
   </>
    );
  }

  return (
    <Container style={{padding:"25px", boxShadow:"none"}}>
      {submitted && response ? (
        <Alert variant="success" className="mt-3">
          <strong>Félicitations {response.user.name} ! </strong>Votre inscription a été envoyée avec succès.
        </Alert>
      ) : (
        <Form onSubmit={handleSubmit}>
          <h1 className="text-center my-4">Inscription des arbitres</h1>
          {error && (
            <Alert variant="danger">
              {error}
            </Alert>
          )}
          <Rgpd showModal={showModal} setShowModal={setShowModal} setRgpdChecked={setRgpdChecked} />
          <Row>
            <Col>
              <Form.Group controlId="nom">
                <Form.Label>Nom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nom"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="prenom">
                <Form.Label>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Prénom"
                  value={prenom}
                  onChange={(e) => setPrenom(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="date" className="mt-3">
            <Form.Label>Date de naissance</Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="telephone" className="mt-3">
            <Form.Label>Numéro de téléphone</Form.Label>
            <Form.Control
              type="text"
              placeholder="0490-508-401"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="Email" className="mt-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="nom.prenom@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="Motpasse" className="mt-3">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              Avec au moins 12 caractères, 1 caractère spécial et 1 chiffre.
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="confirm_mdp" className="mt-3">
            <Form.Label>Confirmer votre mot de passe</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirmer votre mot de passe"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="formFile" className="mt-3">
            <Form.Label>Diplôme d'arbitre en PDF</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={(e) => setFile(e.target.files[0])}
              required
            />
          </Form.Group>
          <Form.Group controlId="rgpd" className="mt-3">
            <Form.Check
              type="checkbox"
              label="En soumettant ce formulaire, j'accepte que mes données personnelles soient traitées conformément aux conditions d'inscription."
              checked={rgpdChecked}
              onChange={() => {
                if (!rgpdChecked) {
                  setShowModal(true);
                } else {
                  setRgpdChecked(false);
                }
              }}
            />
          </Form.Group>
          <br/>
            <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_KEY_CAPTCHA} />
            <br/>
          <div className="text-center">
            <Button variant="primary" type="submit" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} disabled={!rgpdChecked}>
              Inscription
            </Button>
          </div>
        </Form>
      )}
    </Container>
  );
}

export default InscriptionArbitre;
